import React from "react";

interface PatientInfoCardProps {
  isLoading: boolean;
  patientData?: Record<string, any>;
}

export const PatientInfoCard: React.FC<PatientInfoCardProps> = ({
  isLoading,
  patientData,
}) => {
  if (isLoading) {
    return <div className="text-sm text-slate-500">Φόρτωση στοιχείων...</div>;
  }

  if (!patientData || Object.keys(patientData).length === 0) {
    return (
      <div className="text-sm text-slate-500">
        Δεν βρέθηκαν δεδομένα ασθενή.
      </div>
    );
  }

  const filteredEntries = Object.entries(patientData).filter(
    ([key]) =>
      !key.toLowerCase().includes("id") && key !== "__v" && key !== "allergies",
  );

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200 space-y-4">
      <h3 className="text-md font-semibold text-slate-700 border-b pb-2">
        Ατομικά Στοιχεία Ασθενή
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredEntries.map(([key, value]) => (
          <div key={key} className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-600 capitalize">
              {key}
            </label>
            <input
              type="text"
              disabled
              value={value !== null && value !== undefined ? String(value) : ""}
              className="mt-1 block w-full border rounded px-3 py-2 text-sm bg-slate-50 text-slate-700"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
